module.exports = __webpack_public_path__ + "img/banUser.07e0de84.svg";